import React, {useState, useEffect, useRef} from 'react';
import UserJoinRequestForm from './UserJoinRequestForm.mjs';
import UserTeamInvitationsList from './UserTeamInvitationsList.mjs';
import UserTeamJoinRequestsList from './UserTeamJoinRequestsList.mjs';
import UserMembershipDefaultMessage from './UserMembershipDefaultMessage.mjs';
import { useCTAL } from './CTAL_Hooks.js';

export default function UserMembershipCard({app_user, show_invitations}) 
{
    const { user_team_invitations_list, user_join_requests_list } = useCTAL();

    const [img_loc] = useState('./images/'); 
    const [img_ext] = useState('.svg'); 
    const [img_sel] = useState('-sel'); 

    const [img_join_request] = useState('invitation'); //looks backward, but it's not 
    const [img_invitations]  = useState('request'); 
    
    const [img_join_request_file, setImgJoinRequestFile] = useState(img_loc + img_join_request + img_sel + img_ext); 
    const [img_invitations_file,  setImgInvitationsFile] = useState(img_loc + img_invitations  + img_ext); 
   
    const [display_type, setDisplayType] = useState("join-request");
    const [display, setDisplay] = useState(<> <UserJoinRequestForm app_user={app_user} /> </>);
   
    const tooltipRef_invite = useRef(null);
    const tooltipRef_view   = useRef(null);

    useEffect(() => {
        const tooltip_invite = new window.bootstrap.Tooltip(tooltipRef_invite.current, { container: 'body', trigger: 'hover' });
        const tooltip_view   = new window.bootstrap.Tooltip(tooltipRef_view.current, { container: 'body', trigger: 'hover' });
  
        return () => {
            tooltip_invite.dispose();
            tooltip_view.dispose();
        };
    }, []);

    useEffect(() =>
    {
        if (show_invitations) show_display("user-invitations");
    }, []); //Call once

    if (!app_user) return;

    const show_display = (d_type) => { 
        if (display_type == d_type) return;

        setImgJoinRequestFile(img_loc + img_join_request + img_ext);
        setImgInvitationsFile(img_loc + img_invitations  + img_ext);

        switch (d_type)
        {
            case "join-request":
                setImgJoinRequestFile(img_loc + img_join_request + img_sel + img_ext);
                setDisplay( <> <UserJoinRequestForm app_user={app_user} /> </> ); 
                break;
            case "user-invitations":
                setImgInvitationsFile(img_loc + img_invitations  + img_sel + img_ext);
                if ((user_team_invitations_list.length > 0) || (user_join_requests_list.length > 0))
                    setDisplay( <> <UserTeamInvitationsList app_user={app_user} /> <UserTeamJoinRequestsList app_user={app_user} /> </> ); 
                else
                    setDisplay( <> <UserMembershipDefaultMessage /> </> ); 
                break;
        }

        setDisplayType(d_type);
    }

    return (
        <div class="card mt-2">
            <div id="create-join-request-card-header" class="card-header">
                <div class="row">
                    <div class="col text-start">
                        <a href="#"><img class="card-icon" src="./images/request.svg" alt="history" border="0"/></a>
                        <span className="card-sub-title">Memberships</span>
                    </div>
                    <div class="col-5 text-end">
                        <a href="#" ref={tooltipRef_invite} data-bs-toggle="tooltip" data-bs-title="Send Join Request" data-bs-delay="750"><img class="card-icon"     src={img_join_request_file} alt="join request"      border="0" onClick={ () => show_display("join-request") }/></a>
                        <a href="#" ref={tooltipRef_view}   data-bs-toggle="tooltip" data-bs-title="View Invitations"  data-bs-delay="750"><img class="card-icon-end" src={img_invitations_file}  alt="invitations" border="0" onClick={ () => show_display("user-invitations") }/></a>
                    </div>
                </div>
            </div>
            <div class="card-body">
                {display}
            </div>
        </div>
    );
}